import * as Yup from 'yup';

const requiredText = (isCertificatePolicy: boolean) =>
  isCertificatePolicy
    ? Yup.string().trim().notRequired()
    : Yup.string().trim().required('Required');

export const payerOwnerValidationSchema = (isCertificatePolicy: boolean) =>
  Yup.object({
    payerOwner: Yup.object({
      payer: Yup.object({
        addressId: requiredText(isCertificatePolicy),
        id: requiredText(isCertificatePolicy)
      }),
      ownerIsDifferent: Yup.boolean(),
      owner: Yup.object().when('ownerIsDifferent', {
        is: true,
        then: () =>
          Yup.object({
            addressId: requiredText(isCertificatePolicy),
            id: requiredText(isCertificatePolicy)
          }),
        otherwise: () => Yup.object().strip()
      })
    })
  });
